import type { Empresa } from "@/componentes/empresa/tipos"

import { CaratulaCarpeta } from "./CaratulaCarpeta"
import { EtiquetaCarpeta } from "./EtiquetaCarpeta"
import { LomoCarpeta } from "./LomoCarpeta"
import { PestanaCarpeta } from "./PestanaCarpeta"
import { TejueloLibro } from "./TejueloLibro"
import type { DatosRotulo } from "./tipos"

/**
 * Pinta el rótulo que sea. **El único sitio que traduce un tipo a un componente.**
 *
 * ⚠ **Existe para que ese `switch` no se repita.** Lo necesitan la vista previa, el
 * pliego de impresión y el manual de identidad; con una copia en cada uno, añadir un
 * formato obliga a acordarse de todos. Ya pasó con el membrete en el 2.0.
 *
 * El `switch` no tiene rama por defecto a propósito: `DatosRotulo` es una unión
 * cerrada y TypeScript marca como error el día que se añada un tipo y no se pinte.
 */
export function VistaRotulo({
  datos,
  empresa,
  papel,
}: {
  datos: DatosRotulo
  /** La agencia, para la razón social del pie de la carátula. */
  empresa?: Empresa
  /** El color de la cartulina en la vista previa. El pliego NO lo pasa: no se imprime. */
  papel?: string
}) {
  switch (datos.tipo) {
    case "PESTANA":
      return <PestanaCarpeta datos={datos} />
    case "ETIQUETA_CARPETA":
      return <EtiquetaCarpeta datos={datos} />
    case "LOMO":
      return <LomoCarpeta datos={datos} />
    case "CARATULA":
      return <CaratulaCarpeta datos={datos} empresa={empresa} papel={papel} />
    case "TEJUELO":
      return <TejueloLibro datos={datos} />
  }
}
